export const LibraryModalTab = {
	VIDEOS: 'videos',
	PLAYLISTS: 'playlists',
	IMAGES: 'images',
	GFX: 'gfx',
	GFX_VIDEO: 'gfx_videos',
	SCENES: 'scenes',
};
